import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import VideoGrid from 'components/videos/VideoGrid';
import {groupByProject} from 'lib/videos';
import styles from './videos.module.scss';

function getProjects(data) {
  const {GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID} = process.env;
  // We should exclude the popular videos project
  const videos = data.allWistiaVideo.edges.filter(
    ({node: video}) =>
      video.project.id !== parseInt(GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID, 10)
  );

  return groupByProject(videos);
}

const Videos = ({data}) => (
  <section className={classNames('section', styles.Videos)}>
    <Helmet title="Popular Videos | TeamGantt Support">
      <meta
        content="Watch these short videos, and start mastering the basics of TeamGantt"
        name="description"
      />
    </Helmet>
    <div
      className={classNames('container has-text-centered', styles.Videos__hero)}
    >
      <h1 className={classNames(styles.Videos__heading)}>Popular Videos</h1>
      <p className={styles.Videos__summary}>
        Watch these short videos, and start mastering the basics of TeamGantt
      </p>
      <p className="is-size-6">
        Don't have a TeamGantt account?{' '}
        <a href="https://www.teamgantt.com/signup?plan=free">
          Sign up for free.
        </a>
      </p>
    </div>
    <div className={classNames('container', styles.Videos__container)}>
      <VideoGrid projects={getProjects(data)} />
    </div>
  </section>
);

Videos.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Videos;

// eslint-disable-next-line
export const query = graphql`
  query VideoPageQuery {
    allWistiaVideo {
      edges {
        node {
          thumbnail {
            url
          }
          duration
          name
          hashed_id
          project {
            id
            name
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/videos.js